import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastService } from 'ng-uikit-pro-standard';
import { debounceTime, filter } from 'rxjs/operators';
import { DireccionService } from 'src/app/services/direccion.service';
import { EstadoMaquinaService } from 'src/app/services/estado-maquina.service';
import { MaquinaFamiliaService } from 'src/app/services/maquina-familia.service';
import { MaquinaInventarioService } from 'src/app/services/maquina-inventario.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { VendedorService } from 'src/app/services/vendedor.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarClienteComponent } from '../../shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component';
import * as _ from 'lodash';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';
import { RubroService } from 'src/app/services/rubro.service';

@Component({
  selector: 'app-maquinas-reporte-cliente',
  templateUrl: './maquinas-reporte-cliente.component.html',
  styleUrls: ['./maquinas-reporte-cliente.component.scss'],
  providers: [SecurityService],
})
export class MaquinasReporteClienteComponent implements OnInit {
  formHeader: FormGroup;

  // Modales
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent;

  // Data & Tmp
  public rutEmpresa: number;
  public sucursalCodigo: number;
  resumen_currentPayload: any;
  resumen_loading: boolean = false;
  resumen_listaMovimientos: Array<any> = null;
  resumen_listaMovimientosAll: Array<any> = null;
  resumen_paginationContext: PaginationContext = new PaginationContext();

  private detalle_currentPayload: any = null;
  detalle_loading: boolean = false;
  detalle_listaMovimientos: Array<any> = null;
  detalle_listaMovimientosAll: Array<any> = null;
  detalle_paginationContext: PaginationContext = new PaginationContext();

  cliente: any = null;
  readonly RB_TIPO_VISTA_RESUMEN: String = '_RB_TIPO_VISTA_RESUMEN_';
  readonly RB_TIPO_VISTA_DETALLE: String = '_RB_TIPO_VISTA_DETALLE_';

  optionsFamilia: Array<any> = [];

  // optionsVendedor: Array<any> = [];
  optionsEstado: Array<any> = [];
  optionsRubro: Array<any> = [];
  optionsVendedor: Array<any> = [];

  enableClienteInputs: boolean = true;

  // Utils
  private log: any;
  groupArr: any;

  constructor(
    private accesolocalstorage: SecurityService,
    private messageRendererService: MessageRendererService,
    private clog: ConsoleService,
    private toastService: ToastService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private rutService: RutService,
    private vendedorService: VendedorService,
    private datesService: DatesService,
    private estadoMaquinaService: EstadoMaquinaService,
    private maquinaFamiliaService: MaquinaFamiliaService,
    private maquinaInventarioService: MaquinaInventarioService,
    private fileDownloadService: FileDownloadService,
    private rubroService: RubroService
  ) {
    this.log = this.clog.log('MAQUINAS');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.resumen_paginationContext.RecordsByPage = 10;
    this.detalle_paginationContext.RecordsByPage = 10;

    // this.loadVendedores()
    this.loadFamilias();
    this.loadEstados();
    this.loadRubros();
    this.loadVendedores();
    this.createForms();
    this.formChangesSubscriptions();
    if (this.formHeader.get('todos').value === true) {
      this.enableClienteInputs = false;
    }
  }

  loadVendedores(codigoRubro: any = null, totalRubro: number = 0) {
    this.vendedorService.obtenerVendedores(this.rutEmpresa, this.sucursalCodigo, codigoRubro, totalRubro, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      const { registros } = respuesta;
      this.optionsVendedor = registros.map((vendedor) => ({ value: vendedor.codigo, label: vendedor.nombre, ...vendedor }));
    });
  }

  private loadRubros() {
    this.rubroService.obtenerRubros(this.rutEmpresa, ({ respuesta }) => {
      const { registros } = respuesta; //.registros.filter(p => p.estado);
      this.optionsRubro = registros.map((rubro) => ({ value: rubro.codigo, label: rubro.descripcion, ...rubro }));
      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('listaRubro'), this.optionsRubro);
    });
  }
  private loadFamilias() {
    this.maquinaFamiliaService.obtenerTodos(({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      const { registros } = respuesta;
      this.optionsFamilia = registros.map((p) => ({ value: p.codigo, label: p.nombre }));
    });
  }

  // loadVendedores() {
  //   this.vendedorService.obtenerActivos(this.rutEmpresa, this.sucursalCodigo, ({ mensajes, respuesta }) => {
  //     const ok = respuesta !== null
  //     if (!ok) {
  //       this.messageRendererService.showErrors(mensajes)
  //       return
  //     }
  //     const { registros } = respuesta
  //     this.optionsVendedor = registros.map(vendedor => ({ value: vendedor.codigo, label: vendedor.nombre, ...vendedor }))
  //   })
  // }

  loadEstados() {
    this.estadoMaquinaService.obtenerTodos(({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      const { registros } = respuesta;
      this.optionsEstado = registros.map((p) => ({ value: p.codigo, label: p.nombre, ...p }));
    });
  }

  private createForms() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();

    this.formHeader = this.fb.group({
      fechaDesde: [initDate, [Validators.required]],
      fechaHasta: [currentDate, [Validators.required]],
      rutCliente: [null, [Validators.required]],
      todos: [true, [Validators.required]],
      familia: [[], [Validators.required]],
      estado: [[], [Validators.required]],
      ClientesConVenta: [true, [Validators.required]],
      listaRubro: [[]],
      vendedor: [[], [Validators.required]],
      soloClientesSinVenta: [false, [Validators.required]],
      tipoVista: [this.RB_TIPO_VISTA_RESUMEN, [Validators.required]],
    });
  }

  private formChangesSubscriptions() {
    this.formHeader
      .get('rutCliente')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rutCliente: string) => {
        this.modalSeleccionarCliente.searchByRut(rutCliente);
      });

    this.formHeader.get('todos').valueChanges.subscribe((todosClientes: string) => {
      this.enableClienteInputs = !todosClientes;
    });
  }

  openModalSeleccionarcliente() {
    this.modalSeleccionarCliente.show();
  }

  onChangeRubro({ codigo }) {
    const listaRubros = this.formHeader.get('listaRubro').value;
    this.optionsVendedor = [];
    let totalRubro = 0;
    if (listaRubros.length == this.optionsRubro.length) {
      totalRubro = listaRubros.length;
    }
    this.loadVendedores(listaRubros, totalRubro);
  }

  onClienteSeleccionado({ data, origen }) {
    this.cliente = data;
    this.cliente.rutFormato = this.rutService.AgregarDV(this.cliente.rut);
    this.formHeader.get('rutCliente').setValue(this.cliente.rutFormato);
  }

  onClienteNoEncontrado() {
    this.cliente = null;
  }

  buscar(pageNumber: number) {
    this.resumenBuscar(pageNumber);
    this.detalleBuscar(pageNumber);
  }

  //* OBTENER LA VISTA RESUMEN */

  resumenBuscar(pageNumber: number) {
    // this.formValidatorsService.validateAllFormFields(this.formHeader)
    // if (!this.formHeader.valid)
    //   return

    let valid: Boolean = true;

    // if (this.enableClienteInputs && !this.cliente) {
    //   this.toastService.error('Seleccione cliente');
    //   valid = false;
    // }

    if (!valid) return;

    this.resumen_paginationContext.CurrentPage = pageNumber;

    this.resumen_listaMovimientos = null;
    this.resumen_listaMovimientosAll = null;
    const inputParams = {
      filtro: {
        exacto: {
          empresa_rut: this.rutEmpresa,
          cliente_proveedor_rut: this.cliente == null ? 0 : this.cliente.rut,
          fecha_inicio: this.formHeader.get('fechaDesde').value,
          fecha_fin: this.formHeader.get('fechaHasta').value,
          cliente_sin_ventas: this.formHeader.get('ClientesConVenta').value,
          soloClientesSinVenta: this.formHeader.get('soloClientesSinVenta').value,
          listaRubro: this.formHeader.get('listaRubro').value,
          listaVendedor: this.formHeader.get('vendedor').value,
        },
      },
      paginaActual: this.resumen_paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1, //this.resumen_paginationContext.RecordsByPage
    };

    this.resumen_currentPayload = inputParams;

    this.log('inputParams', JSON.stringify(inputParams));

    this.resumen_loading = true;

    this.maquinaInventarioService.obtenerReporteClienteResumen(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
      this.resumen_listaMovimientosAll = registros;
      this.resumen_paginationContext.RecordsCount = totalRegistros;
      this.resumen_paginationContext.PagesCount = Math.ceil(this.resumen_paginationContext.RecordsCount / this.resumen_paginationContext.RecordsByPage); //totalPaginas
      this.resumen_paginationContext.CurrentPage = 1;

      this.resumen_listaMovimientosAll.map((item) => {
        item.rutFormato = this.rutService.AgregarDV(item.cliente_proveedor_rut);
      });
      this.resumen_loading = false;
      this.showPageResumen(this.resumen_paginationContext.CurrentPage);
    });
  }

  showPageResumen(pageNumber: number) {
    this.resumen_paginationContext.CurrentPage = pageNumber;
    const start = (this.resumen_paginationContext.CurrentPage - 1) * this.resumen_paginationContext.RecordsByPage;
    this.resumen_listaMovimientos = _.slice(this.resumen_listaMovimientosAll, start, start + this.resumen_paginationContext.RecordsByPage);
  }

  resumenOnPageChange(context: PaginationContext) {
    this.showPageResumen(context.RequestedPage);
  }
  //* FIN OBTENER LA VISTA RESUMEN */

  //* OBTENER LA VISTA DETALLE */

  detalleBuscar(pageNumber: number) {
    // this.formValidatorsService.validateAllFormFields(this.formHeader)
    // if (!this.formHeader.valid) {
    //   return
    // }

    this.detalle_paginationContext.CurrentPage = pageNumber;

    const { fechaDesde, fechaHasta, familia, estado } = this.formHeader.value;
    const inputParams = {
      filtro: {
        exacto: {
          empresa_rut: this.rutEmpresa,
          cliente_proveedor_rut: this.cliente == null ? 0 : this.cliente.rut,
          fecha_inicio: fechaDesde,
          fecha_fin: fechaHasta,
          cliente_sin_ventas: this.formHeader.get('ClientesConVenta').value,
          soloClientesSinVenta: this.formHeader.get('soloClientesSinVenta').value,
          listaRubro: this.formHeader.get('listaRubro').value,
          listaVendedor: this.formHeader.get('vendedor').value,
        },
      },
      familia: familia,
      estado: estado,
      paginaActual: this.detalle_paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1, //this.detalle_paginationContext.RecordsByPage
    };
    this.detalle_currentPayload = inputParams;
    this.detalle_loading = true;

    this.log('inputParams', JSON.stringify(inputParams));

    this.maquinaInventarioService.obtenerReporteClienteDetalle(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      const { registros } = respuesta;
      this.detalle_listaMovimientosAll = registros;
      this.detalle_paginationContext.RecordsCount = this.detalle_listaMovimientosAll.length; //totalRegistros
      this.detalle_paginationContext.PagesCount = Math.ceil(this.detalle_paginationContext.RecordsCount / this.detalle_paginationContext.RecordsByPage); //totalPaginas
      this.detalle_paginationContext.CurrentPage = 1;
      this.detalle_listaMovimientosAll.map((mov) => {
        mov.rutFormato = this.rutService.AgregarDV(mov.cliente_proveedor_rut);
      });

      this.detalle_loading = false;
      this.showPageDetalle(this.detalle_paginationContext.CurrentPage);
    });
  }

  showPageDetalle(pageNumber: number) {
    this.detalle_paginationContext.CurrentPage = pageNumber;
    const start = (this.detalle_paginationContext.CurrentPage - 1) * this.detalle_paginationContext.RecordsByPage;
    this.detalle_listaMovimientos = _.slice(this.detalle_listaMovimientosAll, start, start + this.detalle_paginationContext.RecordsByPage);
  }

  detalleOnPageChange(context: PaginationContext) {
    this.showPageDetalle(context.RequestedPage);
  }
  //* FIN OBTENER LA VISTA DETALLE */

  //* OBTENER EXCEL/PDF DE LA VISTA RESUMEN Y DETALLE */
  downloadExcelPdfResumen(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.resumen_currentPayload);
    delete inputParams.cantidadRegistrosPorPagina;
    delete inputParams.paginaActual;

    inputParams.filtro.exacto.retornaExcel = type === 'XLS';
    inputParams.filtro.exacto.retornaPDF = type === 'PDF';

    this.log('inputParams', JSON.stringify(inputParams));
    this.maquinaInventarioService.obtenerReporteClienteExcelPdfResumen(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      if (respuesta) this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo);
    });
  }

  downloadExcelPdfDetalle(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.detalle_currentPayload);
    delete inputParams.cantidadRegistrosPorPagina;
    delete inputParams.paginaActual;

    inputParams.filtro.exacto.retornaExcel = type === 'XLS';
    inputParams.filtro.exacto.retornaPDF = type === 'PDF';

    this.log('inputParams', JSON.stringify(inputParams));
    this.maquinaInventarioService.obtenerReporteClienteExcelPdfDetalle(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      if (respuesta) this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo);
    });
  }
}
